import React from "react";
import "./Card.css";

/**
 * Base surface — the shared chrome GameCard, HeroCard, panels, etc. build on.
 * Surface-aware (reads --surface-card / --surface-border). Replaces ad-hoc
 * Box/Paper.
 *
 * Props:
 *   accent:      "none" | "teal" | "gold" | "gradient"  — accent bar (default "none")
 *   accentEdge:  "left" | "top"                          — bar position (default "left")
 *   spotlight:   bool — the brand "featured" card: top gold→teal gradient bar +
 *                teal-tinted border + teal glow (matches design-system .card-spotlight).
 *                Overrides accent/accentEdge.
 *   padding:     "none" | "sm" | "md" | "lg" (default "md")
 *   dashed:      bool — dashed border, transparent fill (the New-game tile)
 *   interactive: bool — hover lift + pointer
 *   as:          element/component (default "div")
 */
const Card = ({
  accent = "none",
  accentEdge = "left",
  spotlight = false,
  padding = "md",
  dashed = false,
  interactive = false,
  as: Tag = "div",
  className = "",
  children,
  ...rest
}) => {
  const accentCls = spotlight
    ? "gx-card--spotlight"
    : `gx-card--accent-${accent} gx-card--edge-${accentEdge}`;
  return (
    <Tag
      className={`gx-card ${accentCls} gx-card--pad-${padding} ${dashed ? "is-dashed" : ""} ${interactive ? "is-interactive" : ""} ${className}`}
      {...rest}
    >
      {children}
    </Tag>
  );
};

export default Card;
